import * as React from 'react';
import { Subscribe } from 'unstated';
import { Homepage, Props as HomepageProps } from '../pages/Homepage';
import { SearchContext } from '../../types';
import { SearchContainer } from '../../BaseLayout/container/SearchContainer';
import { useBreakpointIndex } from '@theme-ui/match-media';

export function ConnectedHomepage() {

  const breakpoint = useBreakpointIndex();
  const getRenderProps = (container: SearchContainer): HomepageProps => {
    const { context: searchContext, term: searchTerm, visibleSearchTerm: changedSearchTerm } = container.state;

    return {
      topVisible: container.state.visible,
      setTopBarVisibility: (visible?: boolean) => {
        if (undefined === visible) {
          container.resetVisible();
        } else {
          container.setVisible(visible);
        }
      },

      searchContext,
      searchTerm,
      changedSearchTerm,

      onSearchSubmit: async (value: string) => {
        await container.setVisibleSearchTerm(value);
        await container.setSearchTerm(value);
        container.submitSearch();
      },
      onSearchContextSelect: (context: SearchContext) => {
        container.setContext(context);
      },
      setSearchTerm: (value: string) => {
        container.setVisibleSearchTerm(value);
      },
      breakpoint
    };
  };

  return React.createElement(Subscribe, {
    to: [SearchContainer],
    children: (c: SearchContainer) => {
      // Get the render props using the state container
      const props = getRenderProps(c);
      return React.createElement(Homepage, props);
    },
  });
}

export default ConnectedHomepage;
